import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'
import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllCompanyDetails extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({exportParams: params})
      let data = await Request.getCompanyDetails({
        ...params,
        regExFilters: []
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }
  handleSubmit = e => {
    const {form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateCompanyDetails(values)
        } else {
          x = await Request.addCompanyDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Commission Updated Successfully`
              : 'Commission Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteCompanyDetails = async data => {
    this.setState({loading: true})
    await Request.deleteCompanyDetails(data)

    this.setState({loading: false})

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  setCompanyDetailsData(companyDetailId) {
    if (companyDetailId) {
      Request.financeCompanyDetailsByID({id: companyDetailId}).then(
        ({doc, error, message}) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1',
            })
            
            this.props.form.setFieldsValue({
              companyName: doc.companyName,
              companyType: doc.companyType,
              companyEmail: doc.companyEmail,
              bankName: doc.bankName,
              bankAddress: doc.bankAddress,
              accountNumber: doc.accountNumber,
              accountName: doc.accountName,
              bankSwiftBicCode: doc.bankSwiftBicCode,
              bankIfscCode: doc.bankIfscCode,
              transitNumber: doc.transitNumber,
              institutionNumber: doc.institutionNumber,
              companyStatus: doc.companyStatus,
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  componentWillMount() {
    
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {
      form: {getFieldDecorator}
    } = this.props
    const { id} = this.state;

    const inputTypes = {
      fields: [
        {
          label: 'Company Name',
          key: 'companyName',
          required: true
        },
        {
          label: 'Company Type',
          key: 'companyType',
          required: true
        },
        {
          label: 'Company Email',
          key: 'companyEmail',
          required: true,
          type: 'email'
        },
        {
          label: 'Bank Name',
          key: 'bankName',
          required: true
        },
        {
          label: 'Bank Address',
          key: 'bankAddress',
          required: true
        },
        {
          label: 'Account Number',
          key: 'accountNumber',
          required: true
        },
        {
          label: 'Account Name',
          key: 'accountName',
          required: true
        },
        {
          label: 'Bank Swift/BIC',
          key: 'bankSwiftBicCode'
        },
        {
          label: 'Bank Ifsc Code',
          key: 'bankIfscCode'
        },
        {
          label: 'Transit Number',
          key: 'transitNumber'
        },
        {
          label: 'Institution Number',
          key: 'institutionNumber'
        },
        {
          label: 'HST Registration Number',
          key: 'HSTRegistrationNumber'
        },
        {
          label: 'Status',
          key: 'companyStatus',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'Active', 'Inactive'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({
              companyStatus: v
            })
          }
        }
      ]
    };

    const columns = [
      {
        title: 'Company Name',
        key: 'companyName',

      },
      {
          title: 'Company Type',
          key: 'companyType',
      },
      {
          title: 'Company Status',
          key: 'companyStatus'
      },
      {
          title: 'Bank Name',
          key: 'bankName'
      },
      {
          title: 'Bank Address',
          key: 'bankAddress'
      },
      {
          title: 'Account Number',
          key: 'accountNumber'
      },
      {
          title: 'Account Name',
          key: 'accountName'
      },
      {
          title: 'Bank Swift/BIC Code',
          key: 'bankSwiftBicIfscCode'
      },
      {
          title: 'Updated By',
          key: 'lastUpdatedByName',
          dataIndex: 'lastUpdatedByName',
          render: (text, record) => {
              return (
                  <div>
                      <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
                      <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
                  </div>
              )
          }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'financeUniversityCommission.edit'}>
              <Tooltip title="Edit Commission">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setCompanyDetailsData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'financeUniversityCommission.delete'}>
              <Tooltip title="Delete Commission">
                <Popconfirm
                  title="Are you sure delete this Commission?"
                  onConfirm={() => {
                    this.deleteCompanyDetails({_id: record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Company Bank Details `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Details`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Company Detail'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllCompanyDetails
